/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates the built in easing type to use for an animation.
 */
export var GridEasingFunctionType = /*@__PURE__*/ (function (GridEasingFunctionType) {
    /**
     * Use linear easing.
     */
    GridEasingFunctionType[GridEasingFunctionType["Linear"] = 0] = "Linear";
    /**
     * Use cubic in/out easing.
     */
    GridEasingFunctionType[GridEasingFunctionType["CubicInOut"] = 1] = "CubicInOut";
    /**
     * Use exponential in/out easing.
     */
    GridEasingFunctionType[GridEasingFunctionType["ExponentialInOut"] = 2] = "ExponentialInOut";
    /**
     * Use circle in/out easing.
     */
    GridEasingFunctionType[GridEasingFunctionType["CircleInOut"] = 3] = "CircleInOut";
    return GridEasingFunctionType;
})({});
/**
 * @hidden
 */
export var GridEasingFunctionType_$type = /*@__PURE__*/ markEnum('GridEasingFunctionType', 'Linear,0|CubicInOut,1|ExponentialInOut,2|CircleInOut,3');
//# sourceMappingURL=GridEasingFunctionType.js.map
